import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/Users/donjuanc/Documents/codwelt/visualinmueble-widget-map-vue/node_modules/css-loader/dist/runtime/api.js'
import '/Users/donjuanc/Documents/codwelt/visualinmueble-widget-map-vue/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/Users/donjuanc/Documents/codwelt/visualinmueble-widget-map-vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

import visualinmuebleMap from '~root/./src/App.vue?shadow'
window.customElements.define('visualinmueble-map', wrap(Vue, visualinmuebleMap))